// extracted by mini-css-extract-plugin
export default {"nav-button":"Navigation_nav-button__CsHW+","center":"Navigation_center__ipDTF"};